import { type ReactNode } from "react";

export const MobileContent = ({ children }: { children: ReactNode }) => (
  <main
    // Margin and bottom clearance come from MobileLayout. Only the top offset
    // is this component's own, for the fixed header above it.
    className="pt-18 min-h-screen overflow-y-auto"
    id="main-content"
  >
    {children}
  </main>
);
